<!--
 * @Author: yubaolee <yubaolee@163.com> | ahfu~ <954478625@qq.com>
 * @Date: 2021-06-01 14:10:29
 * @LastEditTime: 2023-09-14 23:50:35
 * @Description: 
 * @
 * @Copyright (c) 2023 by yubaolee | ahfu~ , All Rights Reserved. 
-->
<template>
  <div class="dashboard-editor-container" id="your-frame-id">
    <!-- <panel-group v-if="Logintype == '1'"></panel-group> -->
    <el-row :gutter="24">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" v-if="Logintype == '1'">
        <div class="wokeLc">
          <div class="wk-nke">
            <img class="icon-blue" src="@/assets/imgqy.png" alt="">
            <div class="title-name">
              {{ username }}
            </div>
          </div>
          <div class="workbottom" @click="$router.push('/public/index/453768453972037')">
            企业信息 &nbsp;&nbsp; <span style="color: #0079ff;">前往详情页面></span>
          </div>
          <!-- <div v-if="parm.total == 0">
            暂无消息...</div> -->
          <div class="SPcontent">
            <el-table :data="this.parm.list" style="width: 100%">
              <el-table-column type="index" width="50" label="序号" align="center">
              </el-table-column>
              <el-table-column prop="typeName" label="消息分类" width="180" align="center">
              </el-table-column>
              <el-table-column prop="fromName" label="发送人" width="70" align="center">
              </el-table-column>
              <el-table-column prop="toStatus" label="状态" width="150" align="center">
                <template slot-scope="scope">
                  <el-tag type="danger" v-if="scope.row.toStatus == 0">未读</el-tag>
                  <el-tag v-if="scope.row.toStatus == 1">已读</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="content" width="150" label="消息内容" align="center">
              </el-table-column>
              <el-table-column prop="createTime" width="150" label="消息时间" align="center">
              </el-table-column>
            </el-table>
          </div>

        </div>
      </el-col>
      <!-- <el-col :xs="24" :sm="24" :md="24" :lg="8">
        <div class="wokeLc">
          <h4>资质维护</h4>
          <div id="mainb" class="zzgl"></div>
        </div>
      </el-col> -->
      <!-- <el-col :xs="24" :sm="24" :md="24" :lg="6">
        <div class="wokeLc">
          <h4>全部通知</h4>
          <div class="workbottom nbb">
            <span class="slh-input">中秋节放假通知1中秋节放假通知2中秋节放假通知</span>
            <span style="color: #ccc;">2024-6-7</span>
          </div>
          <div class="workbottom nbb">
            <span class="slh-input">端午放假通知</span>
            <span style="color: #ccc;">2024-6-7</span>
          </div>
        </div>
      </el-col> -->
      <!-- <el-col :xs="24" :sm="24" :md="24" :lg="24" v-if="Logintype == '1'">
        <div class="wokeLc">
          <div class="wokeheader">
            <div class="wokename">常用功能</div>
            <el-button size="mini" icon="el-icon-plus" @click="wokeadd">添加</el-button>
          </div>
          <div class=" workbottomclas " ref="tagsP">
           
            <el-col :xs="24" :sm="24" :md="24" :lg="24" style="display: flex;flex-wrap: wrap;   overflow: auto;
            height: 170px;">
              <div class="wkicon" v-if="Logintype == '1'">
                <img class="icon-blue" src="@/assets/page.png" alt="">
                <div class="text-icon">
            
                  <a :href="`http://10.168.50.39:12098/#/chart/preview/28?token=${token}`" target="_blank"
                    rel="noopener noreferrer">供应商大屏系统</a>
                </div>
              </div>
              <div class="wkicon" v-else>
                <img class="icon-blue" src="@/assets/page.png" alt="">
                <div class="text-icon">
            
                  <a :href="`http://10.168.50.39:12098/#/chart/preview/30?token=${token}`" target="_blank"
                    rel="noopener noreferrer">院长驾驶仓大屏</a>
                </div>
              </div>
              <div class="wkicon">
                <a :href="`http://10.168.50.39:12098/#/chart/preview/27?token=${token}`" target="_blank"
                  rel="noopener noreferrer" style="text-align: center;">
                  <img class="icon-blue" src="@/assets/ok.png" alt="">
                  <div class="text-icon">
                    部门任务
                  </div>
                </a>
              </div>
              <div class="wkicon" @click="gomessage()">
                <el-badge :value="MsgArrayTotal.totalMsg" class="item" style="text-align: center;">
                  <img class="icon-blue" src="@/assets/Rz.png" alt="">
                  <div class="text-icon">我的消息</div>
                </el-badge>
              </div>
     
              <div class="wkicon" v-for="(i, index) in Pendingmenu " :key="index" @click="goloadio(i)">
                <i :class="`GJDicon   iconfont icon-${i.iconName || 'el-icon-user-solid'}`"
                  style="color: #0079ff; font-size: 40px;"></i>
                <div class="text-icon" style="margin-top: 4px;">{{ i.name }}</div>
              </div>
          

            </el-col>
          </div>

        </div>
      </el-col> -->
      <!-- <el-col :xs="24" :sm="24" :md="24" :lg="8" v-if="Logintype == '2'">
        <div class="wokeLc">
          <el-carousel trigger="click" height="260px">
            <el-carousel-item v-for="item in 4" :key="item">
              <h3 class="small">{{ item }}</h3>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col> -->
      <!-- <el-col :xs="24" :sm="24" :md="24" :lg="8">
        <div class="wokeLc">
          <h4>数据概况</h4>
          <div class="zzgl" id="mainf"></div>

        </div>
      </el-col> -->
      <!-- <el-col :xs="24" :sm="24" :md="24" :lg="6">
        <div class="wokeLc">
        <h4>工作时间 </h4>
         <div class="workbottom" >周一至周五9:00——17:00</div>
         <div class="workbottom" >联系电话:110112113114</div>
        </div>
      </el-col> -->
    </el-row>
    <!-- <el-row :gutter="24">
      <el-col :xs="24" :sm="24" :md="24" :lg="24">
        <div class="bg">
          <div class="EchBgd" id="mainT"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="10">
        <div class="bg">
          <div class="EchBgd" id="mainb"></div>
        </div>
      </el-col>
    </el-row> -->
    <!-- <el-row :gutter="24">
      <el-col :xs="24" :sm="12" :md="12" :lg="14">
        <div class="bg">
          <div class="EchBg" id="main"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="10">
        <div class="bg">
          <div class="EchBg" id="mainc"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="14">
        <div class="bg">
          <div class="EchBg" id="maina"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="10">
        <div class="bg">
          <div class="EchBg" id="mainf"></div>
        </div>
      </el-col>
    </el-row> -->
    <totalMsg ref="totalMsg"></totalMsg>
    <el-dialog :title="dialTitle" :visible.sync="showModal" width="80%" ref="sel_el">
      <publicIndex ref="refpublicIndex"></publicIndex>
    </el-dialog>
    <el-dialog :title="dialTitle" :visible.sync="showModal1" width="50%" ref="sel_el" :before-close="clear">
      <div class="muencontent">
        <div class="Caidanxuanz tagsstyG" v-if="Pendingmenu.length > 0">
          <div v-for="(i, index) in Pendingmenu" :key="index" class="bobob" style="position: relative;">
            <i style="position: absolute; right:30px;font-size: 16px; cursor: pointer;color: red;" class="el-icon-remove"
              @click="deleteicon(i)"></i>
            <i :class="`GJDicon   iconfont icon-${i.iconName || 'el-icon-user-solid'}`"
              style="color: #0079ff; font-size: 40px;"></i>
            <div v-if="i.name" slot="title" class="GJDstyclsT">{{
              i.name
            }}</div>
          </div>
          <div class="MXCaidanxuanz" v-if="Pendingmenu.length > 0">
            <el-button type="primary" @click="commit">确定</el-button>
            <!-- <el-button type="info" @click="clear">取消</el-button> -->
          </div>
        </div>

        <div v-for="(i, index) in Menuobj " :key="index">
          <div class="GJDmeun">
            <i :class="`GJDicon   iconfont icon-${i.item.iconName || 'el-icon-user-solid'}`"></i>
            <span v-if="i.item.name" slot="title" class="GJDstycls">{{
              i.item.name
            }}</span>
          </div>

          <div class="wokeLc" style="box-shadow:none;height: 100%;">
            <div class="workbottomclas">
              <div class="MXwkicon" v-for="(k, ix) in i.children" :key="ix" style="justify-content: center;"
                @click="muentadd(k.item)">

                <div v-if="k.item.states"
                  style="position: relative;box-shadow: 1px 1px 10px 1px #ccc; background-color: #ccc;border-radius: 8px;">
                  <i :class="`icon-blue  iconfont icon-${k.item.iconName || 'el-icon-user-solid'}`"
                    style="color: #0079ff; font-size: 40px;"></i>

                </div>
                <div v-else style="position: relative;">
                  <i :class="`icon-blue  iconfont icon-${k.item.iconName || 'el-icon-user-solid'}`"
                    style="color: #0079ff; font-size: 40px;"></i>

                </div>
                <div class="text-icon">{{ k.item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </el-dialog>
  </div>
</template>


<script>
import PanelGroup from './components/PanelGroup'
// echarts 异步加载 (~1.1MB)
// import * as echarts from 'echarts';
import totalMsg from "../../layout/totalMsg";
import * as serverConf from '@/api/serverConf'
// publicIndex 异步加载 (引入 hiprint 531KB + jquery 279KB + canvg 284KB)
// import publicIndex from "../../public/index";
// Sortable 异步加载 (~111KB)
// import Sortable from "sortablejs";
import { getToken, removeToken } from '@/utils/auth'
import * as sysMessages from '@/api/sysmessages'
export default {


  name: 'dashboard-admin',
  data() {
    return {
      token: '',
      Logintype: '1',
      MsgArrayTotal: {
        totalMsg: '',
        OrdinaryMsgTotal: 0,
        ForceMsgTotal: 0,
        NoticeMsgTotal: 0,
      },
      showModal: false,
      showModal1: false,
      dialTitle: '',
      Menuobj: [],
      username: '',
      Pendingmenu: [],
      parm: {
        list: [],
        total: null
      },
      editableTabs: [{
        title: 'Tab 1',
        name: '1',
        content: 'Tab 1 content'
      }, {
        title: 'Tab 2',
        name: '2',
        content: 'Tab 2 content'
      }],
    }
  },
  components: {
    PanelGroup,
    totalMsg,
    publicIndex: () => import(/* webpackChunkName: "chunk-public-index" */ "../../public/index"),
  },

  created() {

    console.log('window', !window.localStorage.getItem('modules'))
    if (!window.localStorage.getItem('modules')) {
      removeToken()
      window.location.href = window.location.origin + "/#/login"
      location.reload();
    }
    this.username = window.localStorage.getItem('username')
    this.token = this.getCookie('X-Token');
    if (JSON.parse(window.localStorage.getItem('MsgArrayTotal'))) {
      this.MsgArrayTotal = JSON.parse(window.localStorage.getItem('MsgArrayTotal'))
    }
    if (JSON.parse(window.localStorage.getItem('Pendingmenu'))) {
      this.Pendingmenu = JSON.parse(window.localStorage.getItem('Pendingmenu'))
    }
    this.getList()


  },
  mounted() {

    this.$nextTick(() => {
      // 异步加载 echarts (~1.1MB) ，加载完后再初始化图表
      import(/* webpackChunkName: "chunk-echarts" */ 'echarts').then(echarts => {
        this._echarts = echarts
        // this.olodeEchs()
        // this.olodeEchsa()
        // this.olodeEchsb()
        // this.olodeEchsc()
        // this.olodeEchsT()
        // this.olodeEchsf()
      })
    })


  },
  methods: {

    //拖拽方法
    rowDrop() {
      const el = document.querySelector(".tagsstyG"); //找到想要拖拽的那一列
      const _this = this;
      var SHUz = this.Pendingmenu
      console.log(el);
      import(/* webpackChunkName: "chunk-sortable" */ "sortablejs").then(({ default: Sortable }) => {
      Sortable.create(el, {
        onEnd({ newIndex, oldIndex }) {
          let dd = _this.Pendingmenu
          console.log(_this.Pendingmenu);
          console.log(oldIndex);
          //oldIIndex拖放前的位置， newIndex拖放后的位置  //tabOptionList为遍历的tab签
          const currRow = _this.editableTabs.splice(oldIndex, 1)[0]; //鼠标拖拽当前的el-tabs-pane
          // console.log(_this.Pendingmenu.splice(oldIndex, 1));
          _this.editableTabs.splice(newIndex, 0, currRow); //tableData 是存放所以el-tabs-pane的数组


        },
      });
      }) // close import().then()


      //  window.localStorage.setItem('Pendingmenu', JSON.stringify(_this.Pendingmenu))
    },
    muentadd(row) {
      row.states = true

      if (this.Pendingmenu) {
        const xx = this.Pendingmenu.find(x => {
          // console.log(x);
          return x.id == row.id
        })
        if (!xx) {
          this.Pendingmenu.push(row)
        } else {
          return this.$message.error('已添加在常用功能！')
        }
      }

    },
    getList() {
      let listQuery = { // 查询条件
        page: 1,
        limit: 20,
        status: 999, //999为全部，0为未读，1为已读
        key: undefined
      }
      sysMessages.getList(listQuery).then(response => {
        console.log(response);
        this.parm.list = Array.isArray(response.data) ? response.data : []
        this.parm.total = response.count
      })
    },
    commit() {
      window.localStorage.setItem('Pendingmenu', JSON.stringify(this.Pendingmenu))
      this.showModal1 = false
    },
    clear() {
      if (JSON.parse(window.localStorage.getItem('Pendingmenu'))) {
        this.Pendingmenu = JSON.parse(window.localStorage.getItem('Pendingmenu'))

      }
      this.showModal1 = false

    },
    gomessage() {
      this.$refs.totalMsg.show()
    },

    goloadio(row) {
      console.log(row);
      if (row) {
        this.dialTitle = row.name
        var str = row.url;
        let url = str.split("=")[1];
        console.log(url); // 33b1aa73-51d6-4d55-b3ae-c3c58adfe05c
        if (url) {
          this.showModal = true
          this.$nextTick(() => {

            this.$refs.refpublicIndex.showopen(url)
          })
        } else {
          return this.$message.error('没有表单formid!')
        }
      }

    },
    deleteicon(row) {
      this.Pendingmenu.filter((x, index) => {
        if (x.id == row.id) {
          this.Pendingmenu.splice(index, 1)
        }
      })

      console.log(row);
    },
    wokeadd() {
      this.showModal1 = true
      this.dialTitle = '菜单分配'
      this.Menuobj = JSON.parse(window.localStorage.getItem('modules'))
      this.Menuobj.forEach(x => {
        if (x.item) {
          x.item.addF = false
        }

        if (x.children) {
          x.children.forEach(y => {
            if (y.item) {
              y.item.addF = false
            }
          })
        }
      })

      if (JSON.parse(window.localStorage.getItem('Pendingmenu'))) {
        this.Pendingmenu = JSON.parse(window.localStorage.getItem('Pendingmenu'))
      }
      this.$nextTick(() => {
        this.rowDrop()
      })
    },
    getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    },
    olodeEchsT() {
      // 基于准备好的dom，初始化echarts实例
      var chartDom = document.getElementById('mainT');
      // 绘制图表
      var myChart = this._echarts.init(chartDom);
      var option;
      const colors = ['#36A3F7', '#46DDD9'];
      option = {
        color: colors,
        tooltip: {
          trigger: 'none',
          axisPointer: {
            type: 'cross'
          }
        },
        title: {
          text: '年度配送率情况', // 标题文本
          // subtext: '这是一个示例标题的副标题', // 副标题文本
          left: 'center', // 标题水平居中
          top: '20px'
        },
        legend: {},
        grid: {
          top: 70,
          bottom: 50
        },

        xAxis: [
          {
            type: 'category',
            axisTick: {
              // alignWithLabel: true
              show: false
            },

            axisLine: {
              onZero: false,
              lineStyle: {
                color: colors[1]
              }
            },
            axisPointer: {
              label: {
                formatter: function (params) {
                  return (
                    '年度配送率  ' +
                    params.value +
                    (params.seriesData.length ? '：' + params.seriesData[0].data : '') + '%'
                  );
                }
              }
            },
            // prettier-ignore
            data: ['2023-1', '2023-2', '2023-3', '2023-4', '2023-5', '2023-6', '2023-7', '2023-8', '2023-9', '2023-10', '2023-11', '2023-12']
          },
          {
            type: 'category',
            axisTick: {
              // alignWithLabel: true
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: colors[0]
              }
            },
            axisPointer: {
              label: {
                formatter: function (params) {
                  return (
                    '年度配送率  ' +
                    params.value +
                    (params.seriesData.length ? '：' + params.seriesData[0].data : '') + '%'
                  );
                }
              }
            },
            // prettier-ignore
            data: ['2023-1', '2023-2', '2023-3', '2023-4', '2023-5', '2023-6', '2023-7', '2023-8', '2023-9', '2023-10', '2023-11', '2023-12']
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              show: true,
              interval: 'auto',
              formatter: '{value} %'//纵坐标百分比
            }

          }
        ],

        series: [
          {
            name: '年度配送率(2023)',
            type: 'line',
            xAxisIndex: 1,
            smooth: true,
            emphasis: {
              focus: 'series'
            },
            data: [
              80, 106, 99, 75, 88, 102, 78, 106, 108, 96, 95, 87
            ]
          },
          {
            name: '年度配送率(2023)',
            type: 'line',
            smooth: true,
            emphasis: {
              focus: 'series'
            },
            data: [
              100, 76, 86, 86, 76, 100, 86, 99, 97, 86, 99, 89
            ]
          }
        ],

      };
      myChart.resize()
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      option && myChart.setOption(option);
    },



    olodeEchs() {
      // 基于准备好的dom，初始化echarts实例
      var chartDom = document.getElementById('main');
      // 绘制图表
      var myChart = this._echarts.init(chartDom);
      var option;

      option = {
        // 标题

        title: {
          text: '科室退货金额TOP4', // 标题文本
          // subtext: '这是一个示例标题的副标题', // 副标题文本
          left: 'center', // 标题水平居中
          top: '20px'
        },
        legend: {
          y: 'top',
          x: 'right',
          data: ['心血管内科', '骨科神经外科', '甲状腺外科', '医学检查科']
        },
        // 坐标轴
        grid: {
          top: "20%",
          left: "2%",
          right: "10%",
          bottom: "5%",
          containLabel: true, //是否包含坐标轴的文字
        },
        // X轴：横向柱状图，将xAxis的type设置为value
        xAxis: {
          type: "value",
          // 坐标轴刻度
          axisTick: {
            show: false
          },
        },
        // Y轴：横向柱状图，将xAxis的type设置为category
        yAxis: {
          type: "category",
          data: ['心血管内科', '骨科神经外科', '甲状腺外科', '医学检查科'],
          name: '单',
          // 坐标轴刻度
          axisTick: {
            show: false
          },
        },
        // 图表内容
        series: [

          {
            type: "bar", // 图表类型
            data: ['559', '443', '235', '1185'], // 数据
            barWidth: 20, // 柱的宽度
            // 柱上面的数值配置
            label: {
              show: true, // 显示值
              position: "right", // 显示位置
              color: "white",
            },
            // 每一个条目的样式配置
            itemStyle: {
              //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [0, 15, 15, 0],
                color: function (params) {
                  // build a color map as your need.
                  var colorList = [
                    '#179AFE',
                    '#B5C334',
                    '#FCCE10',
                    '#E87C25',
                    '#27727B',
                    '#FE8463',
                    '#9BCA63',
                    '#FAD860',
                    '#F3A43B',
                    '#60C0DD',
                    '#D7504B',
                    '#C6E579',
                    '#F4E001',
                    '#F0805A',
                    '#26C0C0'
                  ];
                  return colorList[params.dataIndex];
                },

              }
            },
          },
        ],
        // 提示框设置
        tooltip: {
          trigger: "axis", //触发类型——坐标轴
          // 鼠标移入条目下面的背景
          axisPointer: {
            type: "line",
            z: 0,
            lineStyle: {
              color: "rgba(225,225,225,.3)",
              width: 65,
            },
          },
        },

      }




      window.addEventListener("resize", () => {
        myChart.resize();
      });
      option && myChart.setOption(option);
    },
    olodeEchsa() {
      // 基于准备好的dom，初始化echarts实例
      var chartDom = document.getElementById('maina');
      // 绘制图表
      var myChart = this._echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          show: true,
          type: 'category',
          data: ['09-01', '09-04', '09-05', '09-06', '09-07'],
          // 坐标轴刻度
          axisTick: {
            show: false
          },
        },
        legend: {
          y: 'top',
          x: 'right',
          data: ['09-01', '09-04', '09-05', '09-06', '09-07'],
        },
        title: {
          text: '本月采购入库情况', // 标题文本
          // subtext: '这是一个示例标题的副标题', // 副标题文本
          left: 'center', // 标题水平居中
          top: '20px'
        },
        grid: {
          top: '40%',    // 距离容器顶部的距离，可以根据需要调整
          bottom: '16%', // 距离容器底部的距离，可以根据需要调整
        },
        yAxis: {
          show: true,
          type: 'value',
          name: '条'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var dataIndex = params[0].dataIndex;
            var value = params[0].data;
            return '数据: ' + value;
          }
        },
        series: [
          {
            data: [51253, 392388, 129603, 102882, 70874],
            type: 'bar',
            smooth: true,
            symbol: 'none', // 不展示节点小点点
            itemStyle: {
              //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [20, 20, 0, 0]
              }
            },
            barGap: '0%'
          }
        ],
        color: ['#1485F7']
      };
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      option && myChart.setOption(option);
    },
    olodeEchsf() {
      // 基于准备好的dom，初始化echarts实例
      var chartDom = document.getElementById('mainf');
      // 绘制图表
      var myChart = this._echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '30%',    // 距离容器顶部的距离，可以根据需要调整
          bottom: '10%', // 距离容器底部的距离，可以根据需要调整
          left: "14%",
        },
        legend: {
          y: 'centent',
          x: 'right',
          data: ['新订单', '处理中','待配送','已配送',]
        },
        // title: {
        //   text: '本月采购与科室领用', // 标题文本
        //   // subtext: '这是一个示例标题的副标题', // 副标题文本
        //   left: 'center', // 标题水平居中
        //   top: '20px'
        // },
        xAxis: [
          {
            type: 'category',
            data: ['普通订单', '配送订单'],
            show: true,
            // 坐标轴刻度
            axisTick: {
              show: false
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '（金额）',
            show: true,
          }
        ],
        series: [
          {
            name: '新订单',
            type: 'bar',
            data: [20,0],
            itemStyle: {
              //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [15, 15, 0, 0]
              }
            },
            barGap: '0%'
          },
          {
            name: '处理中',
            type: 'bar',
            data: [40,0],
            itemStyle: {
              //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [15, 15, 0, 0]
              }
            },
            barGap: '0%'
          },
          {
            name: '待配送',
            type: 'bar',
            data: [0, 30],
            itemStyle: {
              //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [15, 15, 0, 0]
              }
            },
            barGap: '0%'
          },
          {
            name: '已配送',
            type: 'bar',
            data: [0, 50],
            itemStyle: {
              //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [15, 15, 0, 0]
              }
            },
            barGap: '0%'
          }
  
        ],
        color: ['#168DF5', '#2AD3D7','#f9a633','#fed71a ']
      };


      myChart.resize();
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      option && myChart.setOption(option);

    },
    olodeEchsb() {
      var chartDom = document.getElementById('mainb');
      var myChart = this._echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          trigger: 'item',
        },
        title: {

          // subtext: '这是一个示例标题的副标题', // 副标题文本
          left: 'center', // 标题水平居中
          top: '0'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: '0%',
        },
        series: [
          {
            radius: ['20%', '60%'],
            center: ['62%', '48%'],
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },

            type: 'pie',
            label: {
              normal: {
                // formatter: `<div>123</div>`,
                formatter: '{per|{c}} 单 ',
                // position: 'inner',
                rich: {
                  c: {
                    color: '#000',
                    lineHeight: 22,
                    fontWeight: 700,
                    // align: 'center'
                  },
                  abg: {
                    backgroundColor: '#333',
                    width: '100%',
                    align: 'right',
                    height: 22,
                    borderRadius: [4, 4, 0, 0],
                  },
                  num: {
                    color: '#000',
                    fontSize: 30,
                    fontWeight: 700,
                  },
                  per: {
                    color: 'red',
                    // backgroundColor: '#334455',
                    fontSize: 20,
                    padding: [2, 4],
                    fontWeight: 700,
                    borderRadius: 2,
                  },
                },
              },
            },
            data: [
              { value: 1, name: '厂家/代理商(不通过)' },
              { value: 2, name: '申请书(不通过)' },
              { value: 4, name: '业务员(不通过)' },
              { value: 22, name: '产品(不通过)' },
              { value: 1, name: '规格(不通过)' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }





      window.addEventListener("resize", () => {
        myChart.resize();
      });
      option && myChart.setOption(option);
    },
    olodeEchsc() {
      // 基于准备好的dom，初始化echarts实例
      var chartDom = document.getElementById('mainc');
      // 绘制图表
      var myChart = this._echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: 'category',
          show: true,
          data: ['23-04', '23-05', '23-06', '23-07', '23-08'],
          // 坐标轴刻度
          axisTick: {
            show: false
          },
        },
        title: {
          text: '采购到货率', // 标题文本
          // subtext: '这是一个示例标题的副标题', // 副标题文本
          left: 'center', // 标题水平居中
          top: '20px'
        },
        grid: {
          top: '30%',    // 距离容器顶部的距离，可以根据需要调整
          bottom: '10%', // 距离容器底部的距离，可以根据需要调整
          left: '10%',
        },
        yAxis: {
          show: true,
          name: '%'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var dataIndex = params[0].dataIndex;
            var value = params[0].data;
            return '数据: ' + value;
          }
        },
        series: [
          {
            data: [3978, 400, 901, 1778, 1290],
            type: 'line',
            smooth: true
          }
        ],
        color: ['#36A3F7']
      };

      window.addEventListener("resize", () => {
        myChart.resize();
      });
      option && myChart.setOption(option);
    }
  }
}



</script>

<style rel="stylesheet/scss" lang="less" scoped>
.auth-box {
  // margin-top: 30px;
  background: #f7f7f7;

  .auth-col {
    border: 1px solid #c8c8c8;

    &.active {
      // background: #0dafff;
      overflow: hidden;
      position: relative;

      .recomment {
        display: inline-block;
        width: 150px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        background: #febd17;
        transform: rotate(-45deg);
        position: absolute;
        left: -45px;
        top: 10px;
        font-size: 14px;
        color: #fff;
        font-weight: normal;
        letter-spacing: 3px;
      }

      .auth-head {}
    }

    &:nth-child(2) {
      border-left: 0;
      border-right: 0;
    }

    &:nth-child(4) {
      border-left: 0;
    }

    // border-right: 
    .auth-head {
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      height: 135px;

      .subTitle {
        display: inline-block;
        font-weight: normal;
        padding-top: 10px;
      }
    }

    >div {
      height: 40px;
      padding: 10px 20px;
      box-sizing: border-box;
      text-align: center;

      .auth-icon {
        font-size: 18px;
        padding: 0 10px;

        .el-icon-success {
          color: #67c23a;
        }

        .el-icon-error {
          color: #f56c6c;
        }
      }
    }

    >div:nth-child(even) {
      background: #e5e5e5;
    }

    .auth-item:nth-child(even) {
      // background: #0dafff;
    }
  }
}

.dashboard-editor-container {
  padding: 20px;
  background: #f7f7f7;
  // min-height: calc(100vh - 84px);
height: 100%;
  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }

  .component-item {
    min-height: 100px;
  }
}

.product {
  max-width: 350px;
  border: 1px solid #dfdfdf;
  padding: 0;
  border-radius: 8px;
  margin-bottom: 20px;
  background-color: white;

  .title {
    padding: 12px;
    text-align: center;
    background-color: #f4f4f4;
    border-radius: 8px 8px 0 0;
  }

  h2 {
    margin: 24px 0 12px;
  }

  .content {
    h2 {
      text-align: center;
      font-size: 30px;
    }

    .tips {
      padding: 0 35px 30px 30px;

      div {
        padding: 8px 0;
        font-size: 15px;

        .el-icon-check {
          width: 30px;
          font-size: 1.5em;
          color: #35affb;
          vertical-align: middle;
        }
      }

      .color-prime {
        color: #338ed6;
        font-weight: 650;

        .el-icon-check {
          color: gray;
        }
      }

      .color-enterprise {
        color: #f56c6c;
        font-weight: 800;

        .el-icon-check {
          color: #67c23a;
        }
      }
    }
  }
}

.action {
  text-align: center;
  padding-bottom: 24px;
  padding: 12px 18px;
  display: flex;
  background: #f4f4f4;

  .btn {
    flex: 1;
    margin: 6px;
    padding: 6px 12px;
    line-height: 26px;
    font-size: 16px;
    background: #fff;
    position: relative;
    cursor: pointer;
    display: inline-block;
    white-space: nowrap;
    border-radius: 4px;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    font-weight: 700;
    text-decoration: none;
    border: 2px solid #4893ff;
    background-color: transparent;
    color: #4893ff;
    transition: all 0.3s;
  }

  a.btn.std {
    color: #0dafff;
    border-color: #0dafff;
  }

  a.btn.premier {
    color: #d67735;
    border-color: #ffa669;
  }
}

.standard .title {
  background: #eaeaea;
  color: #666;
}

.prime {
  margin: 0 auto;
}

.prime .title {
  background: linear-gradient(#338ed6, #4f6eab);
  color: #fff;
}

.enterprise {
  /* margin-left: auto; */
  /* margin-right: 0; */
}

.enterprise .title {
  background: linear-gradient(#807979, #484a4e);
  color: #fff;
}

.EchBg {
  background-color: #fff;
  box-shadow: 4px 4px 6px rgba(0, 0, 0, .1);
  border-radius: 10px;
  width: 100%;
  overflow: hidden;
  height: 250px;

}

.EchBgd {
  background-color: #fff;
  overflow: hidden;
  box-shadow: 4px 4px 6px rgba(0, 0, 0, .1);
  border-radius: 10px;
  width: 100%;
  height: 320px;
  margin: auto;
}

.zzgl {
  // background-color: #fff;
  // overflow: hidden;
  // box-shadow: 4px 4px 6px rgba(0, 0, 0, .1);
  border-radius: 10px;
  width: 100%;
  height: 200px;
  // margin: auto;
}

.wokeLc {
  background-color: #fff;
  box-shadow: 4px 4px 6px rgba(0, 0, 0, .1);
  padding: 20px;
  border-radius: 10px;
  height: 100%;
  margin-bottom: 20px;

  .wokeheader {
    display: flex;
    align-items: center;
    justify-content: space-between;



    .wokename {
      font-weight: 600;
      font-size: 20px;
    }
  }

  .workbottom {
    display: flex;
    align-items: center;
    // justify-content: space-around;

    margin: 10px 0;

    .wokebody {
      flex: 30%;
    }
  }

  .workbottomclas {
    display: flex;
    flex-wrap: wrap;

  }

  .workbottom:hover {
    color: #338ed6;
    cursor: pointer;
  }
}

.bg {
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 20px;
}

.icon-blue {

  width: 48px;
  height: 48px;

}

.wkicon {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  width: 20%;

  margin: 10px 0px;
  cursor: pointer;

  .text-icon {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90px;
    text-align: center;
  }

  div {

    font-weight: 600;
  }
}

.MXwkicon {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* flex: 20%; */
  width: 19%;
  margin: 10px 0px;
  cursor: pointer;

  .text-icon {
    font-size: 14px;
  }

  div {

    font-weight: 600;
  }
}

.wkicon:hover {
  transition: all 0.2s;
  color: #7a7af9;
  transform: scale(1.1);
}

.worktitle {
  display: flex;
  align-items: center;
  // justify-content: space-around;
  width: 100%;
  color: #23b9e2;

  div {
    flex: 30%;
  }
}

/deep/ .el-carousel__indicators {
  bottom: 16px;
}

/deep/ .el-carousel__button {
  background-color: #0078d4;
  height: 8px;
  border-radius: 5px;
}

/deep/ .el-carousel__indicator {
  padding: 14px;
}

/deep/ .el-badge__content.is-fixed {
  position: absolute;
  top: 8px;
  right: 16px;
  /* transform: translateY(-50%) translateX(100%); */
}

.muencontent {
  position: relative;

  .Caidanxuanz {

    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: sticky;
    top: 0%;
    left: 24.9%;
    background-color: #fff;
    box-shadow: 1px 1px 10px 1px #fff;
    border: 1px solid #ccc;
    padding: 20px 0;
    border-radius: 4px;
    width: 100%;
    max-height: 260px;
    margin: 10px 0;
    overflow: auto;
    z-index: 1000;


    .bobob {
      display: flex;
      // flex: 20%;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      width: 17%;
      flex-wrap: wrap;
      // flex: 100%;
      margin: 10px;

    }
  }

  .MXCaidanxuanz {
    display: flex;
    width: 19%;
    // align-items: center;
    justify-content: center;
    // display: flex;
    // flex-wrap: wrap;
    // position: fixed;
    // bottom: 8%;
    // left: 15%;

  }
}


.GJDmeun {
  margin: 10px;
  margin-left: 0;

  /* display: flex; */
  .GJDicon {
    font-size: 20px;
    color: #000;
    margin-right: 10px;
  }

  .GJDstycls {
    // display: block;
    font-size: 20px;
    color: #000;
    overflow: hidden;
    // width: 20px;
    // white-space: nowrap;
    // text-overflow: ellipsis;
  }

}

.GJDstyclsT {
  // display: block;
  font-size: 14px;
  color: #000;
  overflow: hidden;
  width: 100px !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.wk-nke {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #EBEEF2;
  padding-bottom: 10px;

  // justify-content: space-between;
  .title-name {
    font-weight: 600;
    font-size: 22px;
    margin-left: 6px;
  }
}

.SPcontent {
  overflow: hidden;
  overflow-y: auto;
  height: 180px;
}

.nbb {
  display: flex;
  align-items: center;
  justify-content: space-between;

}

.slh-input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 70%;
}
</style>